import { render, staticRenderFns } from "./DiscoveryStatsActiveInstall.vue?vue&type=template&id=3f87beb9"
import script from "./DiscoveryStatsActiveInstall.vue?vue&type=script&lang=js"
export * from "./DiscoveryStatsActiveInstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports